'use strict';

/**
 * Update UI
 * @param {jQuery} $before - The "before" image element whose width is updated
 * @param {jQuery} $handle - The slider handle element whose position is updated
 * @param {number} percentage - The percentage position for the slider (0-100)
 */
function updatePosition($before, $handle, percentage) {
    $before.css('width', percentage + '%');
    $handle.css('left', percentage + '%');
}

/**
 * Get cursor position relative to container
 * @param {jQuery} $container - The container element
 * @param {Event} event - The event object
 * @returns {number} The relative X position
 */
function getRelativeX($container, event) {
    const e = event.originalEvent.touches ? event.originalEvent.touches[0] : event;
    const offset = $container.offset();

    return e.pageX - offset.left;
}

/**
 * Initialize single slider instance
 * @param {jQuery} $container - The container element for the slider
 */
function initSlider($container) {
    const $before = $container.find('.kitchen-focus-slider-img--before');
    const $after = $container.find('.kitchen-focus-slider-img--after');

    if (!$before.length || !$after.length || $container.data('kitchenFocusReady')) return;

    const initial = parseInt($container.data('initial'), 10) || 50;
    let $handle = $container.find('.kitchen-focus-slider-handle');
    let isDragging = false;

    if (!$handle.length) {
        const $handleIcon = $('<div>', { class: 'kitchen-focus-slider-handle_icon' });

        $handle = $('<div>', { class: 'kitchen-focus-slider-handle' });
        $handle.append($handleIcon);
        $container.append($handle);
    }

    updatePosition($before, $handle, initial);

    $handle.on('mousedown touchstart', function (e) {
        e.preventDefault();
        isDragging = true;
    });

    $(window).on('mouseup touchend', function () {
        isDragging = false;
    });

    $(window).on('mousemove touchmove', function (e) {
        if (!isDragging) return;

        const position = getRelativeX($container, e);
        const percentage = Math.min(Math.max((position / $container.outerWidth()) * 100, 0), 100);

        updatePosition($before, $handle, percentage);
    });

    $container.data('kitchenFocusReady', true);
}

$(document).ready(function () {
    const $sliders = $('.kitchen-focus-slider');

    if (!$sliders.length) return;

    $sliders.each(function () {
        initSlider($(this));
    });
});
